import { useEffect } from "react";
import Lenis from "lenis";
import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { Navbar } from "../components/landing/Navbar";
import { Hero } from "../components/landing/Hero";
import { MarqueeStrip } from "../components/landing/MarqueeStrip";
import { Fleet } from "../components/landing/Fleet";
import { Manifesto } from "../components/landing/Manifesto";
import { Process } from "../components/landing/Process";
import { Testimonials } from "../components/landing/Testimonials";
import { Contact } from "../components/landing/Contact";
import { Footer } from "../components/landing/Footer";
import { waLink } from "../lib/site";

export default function Landing() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute("href");
      if (id && id.length > 1) {
        const el = document.querySelector(id);
        if (el) {
          e.preventDefault();
          lenis.scrollTo(el, { offset: -80 });
        }
      }
    };
    document.addEventListener("click", onClick);

    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
      document.removeEventListener("click", onClick);
    };
  }, []);

  return (
    <div className="App grain">
      <Navbar />
      <main>
        <Hero />
        <MarqueeStrip />
        <Fleet />
        <Manifesto />
        <Process />
        <Testimonials />
        <Contact />
      </main>
      <Footer />

      <motion.a
        href={waLink()}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp"
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 2.5, type: "spring", stiffness: 200 }}
        whileHover={{ scale: 1.08 }}
        className="fixed bottom-6 right-6 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg shadow-black/40"
        aria-label="Book on WhatsApp"
      >
        <MessageCircle size={26} />
      </motion.a>
    </div>
  );
}
